import {useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import AdminNav from "../../Components/AdminNav/AdminNav";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import {deleteInternationalBrand, getInternationalBrands} from "../../actions/International";
import {IMAGE_URL} from "../../path";

function ViewInternationalBrands() {

    const location = useLocation();
    const user = location.state.user;
    const [isCollapsed, setIsCollapsed] = useState(true);
    const navigate = useNavigate();
    const [brands, setBrands] = useState<any[]>([]);
    const image_url = IMAGE_URL;

    function getBrands() {
        getInternationalBrands()
            .then((data) => {
                setBrands(data.data.data);
            })
            .catch((error) => {
                console.log(error);
            })
    }

    useEffect(() => {
        getBrands();
    }, []);

    function handleDelete(id: number) {
        const confirmDelete = window.confirm("Are you sure you want to delete this brand?");

        if (!confirmDelete) return; //

        deleteInternationalBrand(id)
            .then(() => {
                getBrands(); // Refresh list
            })
            .catch((error) => {
                console.log(error);
            });
    }




    return (
        <div>
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <div className={`main-admin-page ${isCollapsed ? "collapsed" : "expanded"}`}>
                <div className="content-form-button right-align" style={{marginBottom: '20px'}}>
                    <button
                        type="button"
                        className="button button-right"
                        onClick={() => navigate('/dashboard/international/brands/add', { state: { user } })}
                    >
                        Add Brand
                    </button>
                </div>
                <div className="table-container">
                    <table className="news-table">
                        <thead>
                        <tr>
                            <th style={{ width: "20%" }}>Brand</th>
                            <th style={{ width: "20%" }}>Colour Logo</th>
                            <th style={{ width: "20%" }}>B/W Logo</th>
                            <th style={{ width: "20%" }}>Cover Photo</th>
                            <th style={{ width: "20%" }}>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {brands.map((item) => (
                            <tr key={item.id}>
                                <td>{item.name}</td>
                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                    <img style={{ width: '100px', display:"block", margin:"0 auto" }} src={`${image_url}${item.color_logo}`} alt={`${item.name} Colour Logo`} />
                                </td>

                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                    <img style={{ width: '100px', display:"block", margin:"0 auto" }} src={`${image_url}${item.bw_logo}`} alt={`${item.name} BW Logo`} />
                                </td>

                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                    <img style={{ width: '200px', display:"block", margin:"0 auto" }} src={`${image_url}${item.cover_image}`} alt={`${item.name} Cover Image`} />
                                </td>

                                <td>
                                    <button
                                        className="button small"
                                        onClick={() => navigate(`/dashboard/international/brands/${item.id}/products`, { state: { user } })}
                                        style={{ marginRight: "10px", marginBottom: '10px' }}
                                    >
                                        View Products
                                    </button>
                                    <button
                                        className="button small"
                                        onClick={() => navigate(`/dashboard/international/brands/${item.id}/edit`, { state: { user } })}
                                        style={{ marginRight: "10px", marginBottom: '10px' }}
                                    >
                                        Edit Brand
                                    </button>
                                    <button
                                        className="button small danger"
                                        onClick={() => handleDelete(item.id)}
                                        style={{ color: "black" }}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    )
}

export default ViewInternationalBrands
